import { c as _c } from "react/compiler-runtime";
import { LINKS } from '@/constants/links';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useRef } from 'react';
export function CookiesScript() {
  const $ = _c(5);
  const router = useRouter();
  const handlerAttachedRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== router) {
    t0 = () => {
      if (handlerAttachedRef.current) {
        return;
      }
      const handleClick = e => {
        const target = e.target as HTMLElement;
        if (!target.closest("#skippay_cookie-container")) {
          return;
        }
        const link = target.closest("a");
        if (link instanceof HTMLAnchorElement) {
          e.preventDefault();
          const href = link.getAttribute("href");
          if (href) {
            router.push(href);
          }
        }
      };
      document.addEventListener("click", handleClick);
      handlerAttachedRef.current = true;
      return () => {
        document.removeEventListener("click", handleClick);
        handlerAttachedRef.current = false;
      };
    };
    t1 = [router];
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== router.pathname) {
    const onLoad = function onLoad() {
      const isPrivacyPage = router.pathname === LINKS().privacySettings;
      if (isPrivacyPage) {
        return;
      }
      if ("requestIdleCallback" in window) {
        requestIdleCallback(_temp);
      } else {
        setTimeout(_temp2, 1);
      }
    };
    t2 = <Script src={process.env.NEXT_PUBLIC_BASE_URL + "/sdk/cookie/2.4.0.js"} onLoad={onLoad} strategy="lazyOnload" />;
    $[3] = router.pathname;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp2() {
  window.skippay?.cookie?.show();
}
function _temp() {
  window.skippay?.cookie?.show();
}